/*
  Audit log endpoints.

  The audit table is append only with a hash chain, and denials are recorded as well as
  successes (docs/07-identity-rbac.md I.3). The viewer therefore has to show outcome as a
  first class column, not only a severity, because a denied action with severity notice is
  the interesting row in an investigation.
*/

import { request } from '../client';
import { isMockTransport } from '../config';
import type { AuditEvent } from '../types';

export async function listAuditEvents(search?: string): Promise<readonly AuditEvent[]> {
  if (isMockTransport()) {
    const { mockListAuditEvents } = await import('@/mocks/handlers');
    return mockListAuditEvents(search);
  }
  return request<readonly AuditEvent[]>('/audit/events', {
    query: search === undefined || search === '' ? {} : { search },
  });
}
